/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  LicenseOrdering,
  LicenseUploadCheckErrors,
  LicenseUploadCheckErrorsError,
  LicenseUploadCheckErrorsRequest,
  LicenseUploadImport,
  LicenseUploadImportError,
  LicenseUploadImportRequest,
  LicensedStatus,
  ManagementActionCategory,
  ManagementActionOrdering,
  ManagementActionType,
  MinimalSupportUser,
  MinimalTenantOrdering,
  PaginatedLicenseList,
  PaginatedManagementActionList,
  PaginatedMinimalTenantList,
  PaginatedSupportGroupList,
  PaginatedTenantListList,
  PaginatedTenantRenewalsList,
  PaginatedTenantSeatList,
  PatchedSupportGroupRequest,
  ProductType,
  Region,
  RenewalsOrdering,
  Role,
  SeatOrdering,
  SupportGroup,
  SupportGroupError,
  SupportGroupOrdering,
  SupportGroupRequest,
  TenantOrdering,
  TenantType,
  TenantsStats,
} from '../models';
import {
    LicenseOrderingFromJSON,
    LicenseOrderingToJSON,
    LicenseUploadCheckErrorsFromJSON,
    LicenseUploadCheckErrorsToJSON,
    LicenseUploadCheckErrorsErrorFromJSON,
    LicenseUploadCheckErrorsErrorToJSON,
    LicenseUploadCheckErrorsRequestFromJSON,
    LicenseUploadCheckErrorsRequestToJSON,
    LicenseUploadImportFromJSON,
    LicenseUploadImportToJSON,
    LicenseUploadImportErrorFromJSON,
    LicenseUploadImportErrorToJSON,
    LicenseUploadImportRequestFromJSON,
    LicenseUploadImportRequestToJSON,
    LicensedStatusFromJSON,
    LicensedStatusToJSON,
    ManagementActionCategoryFromJSON,
    ManagementActionCategoryToJSON,
    ManagementActionOrderingFromJSON,
    ManagementActionOrderingToJSON,
    ManagementActionTypeFromJSON,
    ManagementActionTypeToJSON,
    MinimalSupportUserFromJSON,
    MinimalSupportUserToJSON,
    MinimalTenantOrderingFromJSON,
    MinimalTenantOrderingToJSON,
    PaginatedLicenseListFromJSON,
    PaginatedLicenseListToJSON,
    PaginatedManagementActionListFromJSON,
    PaginatedManagementActionListToJSON,
    PaginatedMinimalTenantListFromJSON,
    PaginatedMinimalTenantListToJSON,
    PaginatedSupportGroupListFromJSON,
    PaginatedSupportGroupListToJSON,
    PaginatedTenantListListFromJSON,
    PaginatedTenantListListToJSON,
    PaginatedTenantRenewalsListFromJSON,
    PaginatedTenantRenewalsListToJSON,
    PaginatedTenantSeatListFromJSON,
    PaginatedTenantSeatListToJSON,
    PatchedSupportGroupRequestFromJSON,
    PatchedSupportGroupRequestToJSON,
    ProductTypeFromJSON,
    ProductTypeToJSON,
    RegionFromJSON,
    RegionToJSON,
    RenewalsOrderingFromJSON,
    RenewalsOrderingToJSON,
    RoleFromJSON,
    RoleToJSON,
    SeatOrderingFromJSON,
    SeatOrderingToJSON,
    SupportGroupFromJSON,
    SupportGroupToJSON,
    SupportGroupErrorFromJSON,
    SupportGroupErrorToJSON,
    SupportGroupOrderingFromJSON,
    SupportGroupOrderingToJSON,
    SupportGroupRequestFromJSON,
    SupportGroupRequestToJSON,
    TenantOrderingFromJSON,
    TenantOrderingToJSON,
    TenantTypeFromJSON,
    TenantTypeToJSON,
    TenantsStatsFromJSON,
    TenantsStatsToJSON,
} from '../models';

export interface SupportActionsListRequest {
    action?: ManagementActionType;
    category?: ManagementActionCategory;
    ordering?: ManagementActionOrdering | `-${ManagementActionOrdering}`;
    page?: number;
    pageSize?: number;
    tenant?: string;
    tenantType?: TenantType;
}

export interface SupportGroupsCreateRequest {
    supportGroupRequest: SupportGroupRequest;
}

export interface SupportGroupsDestroyRequest {
    id: string;
}

export interface SupportGroupsListRequest {
    edition?: string;
    name?: string;
    ordering?: SupportGroupOrdering | `-${SupportGroupOrdering}`;
    page?: number;
    pageSize?: number;
    region?: string;
    role?: string;
    supportUser?: string;
    tenant?: string;
}

export interface SupportGroupsPartialUpdateRequest {
    id: string;
    patchedSupportGroupRequest?: PatchedSupportGroupRequest;
}

export interface SupportGroupsRetrieveRequest {
    id: string;
}

export interface SupportGroupsUpdateRequest {
    id: string;
    supportGroupRequest: SupportGroupRequest;
}

export interface SupportLicenseCheckErrorsCreateRequest {
    licenseUploadCheckErrorsRequest: LicenseUploadCheckErrorsRequest;
}

export interface SupportLicenseImportLicensesCreateRequest {
    licenseUploadImportRequest: LicenseUploadImportRequest;
}

export interface SupportLicenseListRequest {
    activationDateAfter?: Date;
    activationDateBefore?: Date;
    autoRenew?: boolean;
    edition?: string;
    expiryDateAfter?: Date;
    expiryDateBefore?: Date;
    isSubscription?: boolean;
    licenseNumber?: string;
    ordering?: LicenseOrdering | `-${LicenseOrdering}`;
    page?: number;
    pageSize?: number;
    product?: Array<string>;
    productSku?: Array<string>;
    productType?: ProductType;
    tenant?: string;
    tenantType?: TenantType;
}

export interface SupportMinimalTenantListRequest {
    ordering?: MinimalTenantOrdering | `-${MinimalTenantOrdering}`;
    page?: number;
    pageSize?: number;
    tenant?: string;
}

export interface SupportRenewalsListRequest {
    ordering?: RenewalsOrdering | `-${RenewalsOrdering}`;
    page?: number;
    pageSize?: number;
    tenant?: string;
    tenantType?: TenantType;
}

export interface SupportSeatListRequest {
    directLicensedEditions?: string;
    firstSeenAfter?: Date;
    firstSeenBefore?: Date;
    licenseNumbers?: string;
    licensedEditions?: string;
    licensedStatus?: LicensedStatus;
    name?: string;
    ordering?: SeatOrdering | `-${SeatOrdering}`;
    page?: number;
    pageSize?: number;
    serial?: string;
    tenant?: string;
    tenantType?: TenantType;
    unlicensedEditions?: string;
    userFacingId?: string;
}

export interface SupportTenantListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    edition?: string;
    editions?: Array<string>;
    email?: string;
    fullManageability?: boolean;
    ordering?: TenantOrdering | `-${TenantOrdering}`;
    page?: number;
    pageSize?: number;
    partner?: string;
    productType?: ProductType;
    products?: Array<string>;
    region?: Region;
    tenant?: string;
    tenantType?: TenantType;
}

export interface SupportTenantStatsRetrieveRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    edition?: string;
    editions?: Array<string>;
    email?: string;
    fullManageability?: boolean;
    ordering?: TenantOrdering | `-${TenantOrdering}`;
    partner?: string;
    productType?: ProductType;
    products?: Array<string>;
    region?: Region;
    tenant?: string;
    tenantType?: TenantType;
}

/**
 * 
 */
export class SupportApi extends runtime.BaseAPI {

    /**
     */
    async supportActionsListRaw(requestParameters: SupportActionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedManagementActionList>> {
        const queryParameters: any = {};

        if (requestParameters.action !== undefined) {
            queryParameters['action'] = requestParameters.action;
        }

        if (requestParameters.category !== undefined) {
            queryParameters['category'] = requestParameters.category;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.tenant !== undefined) {
            queryParameters['tenant'] = requestParameters.tenant;
        }

        if (requestParameters.tenantType !== undefined) {
            queryParameters['tenant_type'] = requestParameters.tenantType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/support/actions/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedManagementActionListFromJSON(jsonValue));
    }

    /**
     */
    async supportActionsList(requestParameters: SupportActionsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedManagementActionList> {
        const response = await this.supportActionsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportGroupsCreateRaw(requestParameters: SupportGroupsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupportGroup>> {
        if (requestParameters.supportGroupRequest === null || requestParameters.supportGroupRequest === undefined) {
            throw new runtime.RequiredError('supportGroupRequest','Required parameter requestParameters.supportGroupRequest was null or undefined when calling supportGroupsCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/support/groups/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportGroupRequestToJSON(requestParameters.supportGroupRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportGroupFromJSON(jsonValue));
    }

    /**
     */
    async supportGroupsCreate(requestParameters: SupportGroupsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupportGroup> {
        const response = await this.supportGroupsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportGroupsDestroyRaw(requestParameters: SupportGroupsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling supportGroupsDestroy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/support/groups/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async supportGroupsDestroy(requestParameters: SupportGroupsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.supportGroupsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async supportGroupsListRaw(requestParameters: SupportGroupsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedSupportGroupList>> {
        const queryParameters: any = {};

        if (requestParameters.edition !== undefined) {
            queryParameters['edition'] = requestParameters.edition;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.region !== undefined) {
            queryParameters['region'] = requestParameters.region;
        }

        if (requestParameters.role !== undefined) {
            queryParameters['role'] = requestParameters.role;
        }

        if (requestParameters.supportUser !== undefined) {
            queryParameters['support_user'] = requestParameters.supportUser;
        }

        if (requestParameters.tenant !== undefined) {
            queryParameters['tenant'] = requestParameters.tenant;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/support/groups/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedSupportGroupListFromJSON(jsonValue));
    }

    /**
     */
    async supportGroupsList(requestParameters: SupportGroupsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedSupportGroupList> {
        const response = await this.supportGroupsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportGroupsPartialUpdateRaw(requestParameters: SupportGroupsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupportGroup>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling supportGroupsPartialUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/support/groups/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedSupportGroupRequestToJSON(requestParameters.patchedSupportGroupRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportGroupFromJSON(jsonValue));
    }

    /**
     */
    async supportGroupsPartialUpdate(requestParameters: SupportGroupsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupportGroup> {
        const response = await this.supportGroupsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportGroupsRetrieveRaw(requestParameters: SupportGroupsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupportGroup>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling supportGroupsRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/support/groups/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportGroupFromJSON(jsonValue));
    }

    /**
     */
    async supportGroupsRetrieve(requestParameters: SupportGroupsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupportGroup> {
        const response = await this.supportGroupsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportGroupsUpdateRaw(requestParameters: SupportGroupsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupportGroup>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling supportGroupsUpdate.');
        }

        if (requestParameters.supportGroupRequest === null || requestParameters.supportGroupRequest === undefined) {
            throw new runtime.RequiredError('supportGroupRequest','Required parameter requestParameters.supportGroupRequest was null or undefined when calling supportGroupsUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/support/groups/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportGroupRequestToJSON(requestParameters.supportGroupRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportGroupFromJSON(jsonValue));
    }

    /**
     */
    async supportGroupsUpdate(requestParameters: SupportGroupsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupportGroup> {
        const response = await this.supportGroupsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Provide an endpoint to allow a user to upload a CSV file and test whether it is suitable for importing.
     */
    async supportLicenseCheckErrorsCreateRaw(requestParameters: SupportLicenseCheckErrorsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LicenseUploadCheckErrors>> {
        if (requestParameters.licenseUploadCheckErrorsRequest === null || requestParameters.licenseUploadCheckErrorsRequest === undefined) {
            throw new runtime.RequiredError('licenseUploadCheckErrorsRequest','Required parameter requestParameters.licenseUploadCheckErrorsRequest was null or undefined when calling supportLicenseCheckErrorsCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/support/license/check_errors/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LicenseUploadCheckErrorsRequestToJSON(requestParameters.licenseUploadCheckErrorsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LicenseUploadCheckErrorsFromJSON(jsonValue));
    }

    /**
     * Provide an endpoint to allow a user to upload a CSV file and test whether it is suitable for importing.
     */
    async supportLicenseCheckErrorsCreate(requestParameters: SupportLicenseCheckErrorsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LicenseUploadCheckErrors> {
        const response = await this.supportLicenseCheckErrorsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportLicenseImportLicensesCreateRaw(requestParameters: SupportLicenseImportLicensesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LicenseUploadImport>> {
        if (requestParameters.licenseUploadImportRequest === null || requestParameters.licenseUploadImportRequest === undefined) {
            throw new runtime.RequiredError('licenseUploadImportRequest','Required parameter requestParameters.licenseUploadImportRequest was null or undefined when calling supportLicenseImportLicensesCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/support/license/import_licenses/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LicenseUploadImportRequestToJSON(requestParameters.licenseUploadImportRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LicenseUploadImportFromJSON(jsonValue));
    }

    /**
     */
    async supportLicenseImportLicensesCreate(requestParameters: SupportLicenseImportLicensesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LicenseUploadImport> {
        const response = await this.supportLicenseImportLicensesCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportLicenseListRaw(requestParameters: SupportLicenseListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedLicenseList>> {
        const queryParameters: any = {};

        if (requestParameters.activationDateAfter !== undefined) {
            queryParameters['activation_date_after'] = (requestParameters.activationDateAfter as any).toISOString().substr(0,10);
        }

        if (requestParameters.activationDateBefore !== undefined) {
            queryParameters['activation_date_before'] = (requestParameters.activationDateBefore as any).toISOString().substr(0,10);
        }

        if (requestParameters.autoRenew !== undefined) {
            queryParameters['auto_renew'] = requestParameters.autoRenew;
        }

        if (requestParameters.edition !== undefined) {
            queryParameters['edition'] = requestParameters.edition;
        }

        if (requestParameters.expiryDateAfter !== undefined) {
            queryParameters['expiry_date_after'] = (requestParameters.expiryDateAfter as any).toISOString().substr(0,10);
        }

        if (requestParameters.expiryDateBefore !== undefined) {
            queryParameters['expiry_date_before'] = (requestParameters.expiryDateBefore as any).toISOString().substr(0,10);
        }

        if (requestParameters.isSubscription !== undefined) {
            queryParameters['is_subscription'] = requestParameters.isSubscription;
        }

        if (requestParameters.licenseNumber !== undefined) {
            queryParameters['license_number'] = requestParameters.licenseNumber;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.product) {
            queryParameters['product'] = requestParameters.product;
        }

        if (requestParameters.productSku) {
            queryParameters['product_sku'] = requestParameters.productSku;
        }

        if (requestParameters.productType !== undefined) {
            queryParameters['product_type'] = requestParameters.productType;
        }

        if (requestParameters.tenant !== undefined) {
            queryParameters['tenant'] = requestParameters.tenant;
        }

        if (requestParameters.tenantType !== undefined) {
            queryParameters['tenant_type'] = requestParameters.tenantType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/support/license/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedLicenseListFromJSON(jsonValue));
    }

    /**
     */
    async supportLicenseList(requestParameters: SupportLicenseListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedLicenseList> {
        const response = await this.supportLicenseListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A view of tenants names and IDs used to populate tenant selections. Don\'t use existing views to limit what data support admins are provided.
     */
    async supportMinimalTenantListRaw(requestParameters: SupportMinimalTenantListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedMinimalTenantList>> {
        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.tenant !== undefined) {
            queryParameters['tenant'] = requestParameters.tenant;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/support/minimal-tenant/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedMinimalTenantListFromJSON(jsonValue));
    }

    /**
     * A view of tenants names and IDs used to populate tenant selections. Don\'t use existing views to limit what data support admins are provided.
     */
    async supportMinimalTenantList(requestParameters: SupportMinimalTenantListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedMinimalTenantList> {
        const response = await this.supportMinimalTenantListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportRenewalsListRaw(requestParameters: SupportRenewalsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedTenantRenewalsList>> {
        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.tenant !== undefined) {
            queryParameters['tenant'] = requestParameters.tenant;
        }

        if (requestParameters.tenantType !== undefined) {
            queryParameters['tenant_type'] = requestParameters.tenantType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/support/renewals/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedTenantRenewalsListFromJSON(jsonValue));
    }

    /**
     */
    async supportRenewalsList(requestParameters: SupportRenewalsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedTenantRenewalsList> {
        const response = await this.supportRenewalsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportRolesListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Role>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/support/roles/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleFromJSON));
    }

    /**
     */
    async supportRolesList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Role>> {
        const response = await this.supportRolesListRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async supportSeatListRaw(requestParameters: SupportSeatListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedTenantSeatList>> {
        const queryParameters: any = {};

        if (requestParameters.directLicensedEditions !== undefined) {
            queryParameters['direct_licensed_editions'] = requestParameters.directLicensedEditions;
        }

        if (requestParameters.firstSeenAfter !== undefined) {
            queryParameters['first_seen_after'] = (requestParameters.firstSeenAfter as any).toISOString().substr(0,10);
        }

        if (requestParameters.firstSeenBefore !== undefined) {
            queryParameters['first_seen_before'] = (requestParameters.firstSeenBefore as any).toISOString().substr(0,10);
        }

        if (requestParameters.licenseNumbers !== undefined) {
            queryParameters['license_numbers'] = requestParameters.licenseNumbers;
        }

        if (requestParameters.licensedEditions !== undefined) {
            queryParameters['licensed_editions'] = requestParameters.licensedEditions;
        }

        if (requestParameters.licensedStatus !== undefined) {
            queryParameters['licensed_status'] = requestParameters.licensedStatus;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.serial !== undefined) {
            queryParameters['serial'] = requestParameters.serial;
        }

        if (requestParameters.tenant !== undefined) {
            queryParameters['tenant'] = requestParameters.tenant;
        }

        if (requestParameters.tenantType !== undefined) {
            queryParameters['tenant_type'] = requestParameters.tenantType;
        }

        if (requestParameters.unlicensedEditions !== undefined) {
            queryParameters['unlicensed_editions'] = requestParameters.unlicensedEditions;
        }

        if (requestParameters.userFacingId !== undefined) {
            queryParameters['user_facing_id'] = requestParameters.userFacingId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/support/seat/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedTenantSeatListFromJSON(jsonValue));
    }

    /**
     */
    async supportSeatList(requestParameters: SupportSeatListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedTenantSeatList> {
        const response = await this.supportSeatListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportTenantListRaw(requestParameters: SupportTenantListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedTenantListList>> {
        const queryParameters: any = {};

        if (requestParameters.createdAtAfter !== undefined) {
            queryParameters['created_at_after'] = (requestParameters.createdAtAfter as any).toISOString().substr(0,10);
        }

        if (requestParameters.createdAtBefore !== undefined) {
            queryParameters['created_at_before'] = (requestParameters.createdAtBefore as any).toISOString().substr(0,10);
        }

        if (requestParameters.edition !== undefined) {
            queryParameters['edition'] = requestParameters.edition;
        }

        if (requestParameters.editions) {
            queryParameters['editions'] = requestParameters.editions;
        }

        if (requestParameters.email !== undefined) {
            queryParameters['email'] = requestParameters.email;
        }

        if (requestParameters.fullManageability !== undefined) {
            queryParameters['full_manageability'] = requestParameters.fullManageability;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.partner !== undefined) {
            queryParameters['partner'] = requestParameters.partner;
        }

        if (requestParameters.productType !== undefined) {
            queryParameters['product_type'] = requestParameters.productType;
        }

        if (requestParameters.products) {
            queryParameters['products'] = requestParameters.products;
        }

        if (requestParameters.region !== undefined) {
            queryParameters['region'] = requestParameters.region;
        }

        if (requestParameters.tenant !== undefined) {
            queryParameters['tenant'] = requestParameters.tenant;
        }

        if (requestParameters.tenantType !== undefined) {
            queryParameters['tenant_type'] = requestParameters.tenantType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/support/tenant/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedTenantListListFromJSON(jsonValue));
    }

    /**
     */
    async supportTenantList(requestParameters: SupportTenantListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedTenantListList> {
        const response = await this.supportTenantListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportTenantStatsRetrieveRaw(requestParameters: SupportTenantStatsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantsStats>> {
        const queryParameters: any = {};

        if (requestParameters.createdAtAfter !== undefined) {
            queryParameters['created_at_after'] = (requestParameters.createdAtAfter as any).toISOString().substr(0,10);
        }

        if (requestParameters.createdAtBefore !== undefined) {
            queryParameters['created_at_before'] = (requestParameters.createdAtBefore as any).toISOString().substr(0,10);
        }

        if (requestParameters.edition !== undefined) {
            queryParameters['edition'] = requestParameters.edition;
        }

        if (requestParameters.editions) {
            queryParameters['editions'] = requestParameters.editions;
        }

        if (requestParameters.email !== undefined) {
            queryParameters['email'] = requestParameters.email;
        }

        if (requestParameters.fullManageability !== undefined) {
            queryParameters['full_manageability'] = requestParameters.fullManageability;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.partner !== undefined) {
            queryParameters['partner'] = requestParameters.partner;
        }

        if (requestParameters.productType !== undefined) {
            queryParameters['product_type'] = requestParameters.productType;
        }

        if (requestParameters.products) {
            queryParameters['products'] = requestParameters.products;
        }

        if (requestParameters.region !== undefined) {
            queryParameters['region'] = requestParameters.region;
        }

        if (requestParameters.tenant !== undefined) {
            queryParameters['tenant'] = requestParameters.tenant;
        }

        if (requestParameters.tenantType !== undefined) {
            queryParameters['tenant_type'] = requestParameters.tenantType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/support/tenant/stats/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantsStatsFromJSON(jsonValue));
    }

    /**
     */
    async supportTenantStatsRetrieve(requestParameters: SupportTenantStatsRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantsStats> {
        const response = await this.supportTenantStatsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportUsersListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MinimalSupportUser>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/support/users/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MinimalSupportUserFromJSON));
    }

    /**
     */
    async supportUsersList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MinimalSupportUser>> {
        const response = await this.supportUsersListRaw(initOverrides);
        return await response.value();
    }

}
